import { render, staticRenderFns } from "./GeneralAction.vue?vue&type=template&id=0425da18"
import script from "./GeneralAction.vue?vue&type=script&lang=js"
export * from "./GeneralAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports